import * as React from 'react';
import { SetComponent } from './SetComponent';
/**
 * The component capable of batch setting layout components.
 */
export function SetLayout({ layout = {} }) {
    return (React.createElement(React.Fragment, null, Object.keys(layout).map((key) => (React.createElement(SetComponent, { name: key, component: layout[key], key: key })))));
}
//# sourceMappingURL=SetLayout.js.map